// Highlights the "On This Page" link for the section currently in view and slides
// a marker beside it. Markup: a container with data-scroll-spy, .toc-link links to
// #section ids inside it, and one element with data-scroll-spy-marker. If the list sits in its own
// scrolling box (data-scroll-spy-scroller), that box follows the active link.
const OFFSET = 120; // px from the top of the viewport that counts as "reading here"

export default function initScrollSpy() {
	document.querySelectorAll("[data-scroll-spy]").forEach((nav) => {
		const marker = nav.querySelector("[data-scroll-spy-marker]");
		const links = [...nav.querySelectorAll('a.toc-link[href^="#"]')]; // group headings aren't tracked
		const sections = links
			.map((link) => ({ link, section: document.getElementById(link.hash.slice(1)) }))
			.filter(({ section }) => section);
		if (!sections.length) return;

		const scroller = nav.closest("[data-scroll-spy-scroller]");
		let current = null;

		// Keep the active link inside the scrolling rail without moving the page.
		const reveal = (link) => {
			if (!scroller) return;
			const top = link.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
			const margin = scroller.clientHeight / 3;
			if (top < margin || top > scroller.clientHeight - margin) {
				scroller.scrollTop += top - scroller.clientHeight / 2;
			}
		};

		const activate = (entry) => {
			if (entry !== current) {
				current?.link.classList.remove("is-active");
				entry.link.classList.add("is-active");
			}
			// Always reposition: a filter can move the link without changing which one is active.
			if (marker) {
				marker.style.opacity = "1";
				marker.style.transform = `translateY(${entry.link.offsetTop}px)`;
				marker.style.height = `${entry.link.offsetHeight}px`;
			}
			if (entry !== current) reveal(entry.link);
			current = entry;
		};

		const update = () => {
			const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
			// Skip sections hidden by a filter; they report a top of 0.
			const visible = sections.filter(({ section }) => section.offsetParent !== null);
			if (!visible.length) return;
			let active = visible[0];
			for (const entry of visible) {
				if (entry.section.getBoundingClientRect().top - OFFSET <= 0) active = entry;
			}
			if (atBottom) active = visible[visible.length - 1];
			activate(active);
		};

		let queued = false;
		const onScroll = () => {
			if (queued) return;
			queued = true;
			requestAnimationFrame(() => { queued = false; update(); });
		};

		window.addEventListener("scroll", onScroll, { passive: true });
		window.addEventListener("resize", onScroll);
		document.addEventListener("input", onScroll); // a search filter reflows the page
		update();
	});
}
